import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from './auth-store'
import type { Capability } from './capabilities'

interface ProtectedRouteProps {
  capability?: Capability
}

/**
 * Route gate. Two modes:
 *   - No `capability` → just requires a logged-in user.
 *   - `capability` → requires the user to have that capability.
 *
 * Not-logged-in → redirect to /login with `from` for post-login return.
 * Logged-in but lacks capability → redirect to /forbidden (rendered as `<AccessDenied>`).
 */
export function ProtectedRoute({ capability }: ProtectedRouteProps) {
  const location = useLocation()
  const { token, user, hasCapability } = useAuthStore()

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  if (capability && !hasCapability(capability)) {
    return <Navigate to="/forbidden" replace />
  }
  return <Outlet />
}
